import LoadingGif from "../img/loading-break.gif"

const LoadingAnimation = ({width, height})  => {
    return (
        <img className="BREIKKI-loading-animation" src={LoadingGif} alt="" width={width} height={height}/>
    )
}


export default LoadingAnimation